module.exports = __webpack_public_path__ + "img/new-shipment-active.c2edb076.svg";